var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPaymentCard = function SvgPaymentCard(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "currentColor",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 0H1.45C0.64525 0 0.00724999 0.64525 0.00724999 1.45L0 10.15C0 10.9548 0.64525 11.6 1.45 11.6H13.05C13.8548 11.6 14.5 10.9548 14.5 10.15V1.45C14.5 0.64525 13.8548 0 13.05 0ZM13.05 10.15H1.45V5.8H13.05V10.15ZM13.05 2.9H1.45V1.45H13.05V2.9Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paymentCard.e5a098da.svg";
export { ForwardRef as ReactComponent };